import { getLinkSafetyConfig } from "~/src/utils/link-safety";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { getChatConfig } from "~/src/utils/get-chat-config";
import { useCallback } from "react";
import { QUERY_KEY } from "~/src/constants/queryKeys";

const AVACUS_APP_CONFIG_URL = import.meta.env.VITE_AVACUS_APP_CONFIG_URL;

export const useGetAvacusAppConfig: any = () => {
  const fetchAvacusAppConfig = useCallback(async () => {
    try {
      if (!AVACUS_APP_CONFIG_URL) {
        console.warn("Missing VITE_AVACUS_APP_CONFIG_URL");
        return {};
      }

      const response: any = await axios.get(AVACUS_APP_CONFIG_URL, {
        headers: {
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
        },
        params: {
          t: Date.now(),
        },
      });
      return {
        ...getChatConfig(response?.data),
        trustedLinkHosts: getLinkSafetyConfig(response?.data),
      };
    } catch (e) {
      console.warn("Can't fetch avacus app config");
      return {};
    }
  }, []);

  const { data: chatConfig } = useQuery({
    queryKey: [QUERY_KEY.appConfig],
    queryFn: async () => {
      const data = await fetchAvacusAppConfig();
      return data;
    },
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: "always",
  });

  return {
    chatConfig,
  };
};
